"use client";
import React, { useState } from "react";
import AciV2Hardware from "./aciV2Hardware";
import AciMultiHardware from "./aciMultiHardware";
import { SectionDivider } from "app/components/shared/SectionDivider";
import { Flex, Button, Box } from "@chakra-ui/react";

const HardwareAndSoftware = () => {
  const [selectedOption, setSelectedOption] = useState("ACI V2");
  const handleClick = (option) => {
    setSelectedOption(option);
  };
  return (
    <Box data-cy="section-hardware">
      <SectionDivider label="Hardware And Software Details" />
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={"15px"}
        justifyContent={"center"}
        mt={5}
        mb={10}
      >
        <Button
          onClick={() => handleClick("ACI V2")}
          width={{ base: "100%", md: "30%" }}
          height={"55px"}
          color={selectedOption === "ACI V2" ? "black" : "white"}
          bgColor={selectedOption === "ACI V2" ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          ACI V2 Hardware
        </Button>
        <Button
          onClick={() => handleClick("ACI Multi")}
          width={{ base: "100%", md: "30%" }}
          height={"55px"}
          color={selectedOption === "ACI Multi" ? "black" : "white"}
          bgColor={selectedOption === "ACI Multi" ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          ACI V2 Multi-Site-MultiPOD Hardware
        </Button>
      </Flex>
      {selectedOption === "ACI V2" && <AciV2Hardware />}
      {selectedOption === "ACI Multi" && <AciMultiHardware />}
    </Box>
  );
};

export default HardwareAndSoftware;
